import { useQuery } from '@tanstack/react-query';
import { debtCancellationCacheKey } from './debt-cancellation-get-cache-key';
import queryFnFactory from './debt-cancellation-get-query';
export function useDebtCancellationGetQuery({ config, keyProps, queryOptions = {} }) {
    return useQuery({
        queryKey: debtCancellationCacheKey(keyProps),
        queryFn: queryFnFactory(config, keyProps),
        refetchOnMount: 'always',
        ...queryOptions
    });
}
